import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { BookingDTO, OrderDTO } from '@lkp/parking-sdk';
import { Subject, takeUntil } from 'rxjs';
import { GetBooking } from 'src/app/core/states/bookings/booking.actions';

@Component({
    selector: 'app-order-items',
    templateUrl: './order-items.component.html',
    styleUrls: ['./order-items.component.scss'],
    standalone: false
})
export class OrderItemsComponent {
  @Input() order?: OrderDTO;
  @Input() currentBooking?: BookingDTO;
  @Input() renderType: 'order' | 'booking' = 'booking';
  readonly onDestroy$ = new Subject<void>();

  constructor(readonly router: Router, readonly store: Store) {}

  showBooking(id: number | undefined) {
    if (id !== undefined) {
      this.store
        .dispatch(new GetBooking(id))
        .pipe(takeUntil(this.onDestroy$))
        .subscribe({
          next: () => {
            // open single page view
            this.router.navigate(['bokning']);
          },
          error: (error) => console.error('Error fetching booking: ', error),
        });
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    this.order = undefined;
  }
}
